import React from "react";

import * as R from "ramda";

import { Box } from "./base";

import { ThemeProvider } from "emotion-theming";

import { withProps } from "recompose";

import { defaultTheme } from "src/styles";

const roundedCorners = {
  borderRadius: [2, 2, 5],
  borderBottomLeftRadius: [0, 0, 0],
  borderBottomRightRadius: [0, 0, 0],
};

const shadow = {
  boxShadow: 2,
};

const adjustTheme = themeName => theme => {
  const themeKey = R.toLower(themeName);

  return R.merge(
    {
      primaryColor: theme.colors[themeKey],
      primaryColorHover: theme.colors[`${themeKey}Hover`],
      primaryColorLight: theme.colors[`${themeKey}Light`],
      primaryColorAlt: theme.colors[`${themeKey}Alt`],
    },
    theme
  );
};

const PageContainer = withProps(
  ({ roundTopCorners, bg = "white", pb = [1, 1, 4], isFullPage }) =>
    isFullPage
      ? {
          bg,
          pb,
        }
      : {
          ...shadow,
          bg,
          pb,
          ...(roundTopCorners && {
            ...roundedCorners,
            borderRadius: [0, 0, 5],
          }),
        }
)(props => (
  <ThemeProvider theme={adjustTheme(props.themeName || defaultTheme)}>
    <Box {...props} />
  </ThemeProvider>
));

PageContainer.roundedCorners = roundedCorners;

PageContainer.shadow = shadow;

export default PageContainer;



// WEBPACK FOOTER //
// ./src/components/PageContainer.js